/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, {useMemo} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {dashboard, doctor, logout, menuicon09, menuicon17, staffs, patients, sidemenu} from '../../../imagepath'
import Scrollbars from 'react-custom-scrollbars-2'
import {useRole} from '../../../../hooks/use-role'
import {USER_ROLES} from '../../../../constants/roles'
import {ConfigProvider, Menu} from 'antd'

export const Sidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname.split('/').pop()
  const {role} = useRole()

  React.useEffect(() => {
    document.body.classList.add('mini-sidebar')
  }, [])

  const onLogout = () => {
    navigate('/login', {replace: true})
    localStorage.clear()
  }

  const menuItems = useMemo(() => {
    if (role === USER_ROLES.SALES_MANAGER) {
      return [
        {
          key: 'dashboard',
          icon: (
            <span className="menu-side">
              <img src={dashboard} alt="" />
            </span>
          ),
          label: <Link to="/dashboard">Dashboard</Link>,
        },
        {
          key: 'clients',
          icon: (
            <span className="menu-side">
              <img src={patients} alt="" />
            </span>
          ),
          label: <Link to="/clients">Mijozlar</Link>,
        },
        {
          key: 'bron-clients',
          icon: (
            <span className="menu-side">
              <img src={patients} alt="" style={{ filter: 'hue-rotate(240deg)' }} />
            </span>
          ),
          label: <Link to="/bron-clients">Bron qilinganlar</Link>,
        },
        {
          key: 'add-object',
          icon: (
            <span className="menu-side">
              <img src={menuicon17} alt="" />
            </span>
          ),
          label: <Link to="/add-object">Obyektlar</Link>,
        },
      ]
    }

    return [
      {
        key: 'dashboard',
        icon: (
          <span className="menu-side">
            <img src={dashboard} alt="" />
          </span>
        ),
        label: <Link to="/dashboard">Dashboard</Link>,
      },
      {
        key: 'investors',
        icon: (
          <span className="menu-side">
            <img src={doctor} alt="" />
          </span>
        ),
        label: <Link to="/investors">Investorlar</Link>,
      },
      {
        key: 'clients',
        icon: (
          <span className="menu-side">
            <img src={patients} alt="" />
          </span>
        ),
        label: <Link to="/clients">Mijozlar</Link>,
      },
      {
        key: 'bron-clients',
        icon: (
          <span className="menu-side">
            <img src={patients} alt="" style={{ filter: 'hue-rotate(240deg)' }} />
          </span>
        ),
        label: <Link to="/bron-clients">Bron qilinganlar</Link>,
      },
      {
        key: 'expenses',
        icon: (
          <span className="menu-side">
            <img src={menuicon09} alt="" />
          </span>
        ),
        label: <Link to="/expenses">Xarajatlar</Link>,
      },
      {
        key: 'add-object',
        icon: (
          <span className="menu-side">
            <img src={menuicon17} alt="" />
          </span>
        ),
        label: <Link to="/add-object">Obyekt qo'shish</Link>,
      },
      {
        key: 'staffs',
        icon: (
          <span className="menu-side">
            <img src={staffs} alt="" />
          </span>
        ),
        label: <Link to="/staffs">Xodimlar</Link>,
      },
      ...(role === USER_ROLES.ADMIN
        ? [
            {
              key: 'accountants',
              icon: (
                <span className="menu-side">
                  <img src={sidemenu} alt="" />
                </span>
              ),
              label: <Link to="/accountants">Foydalanuvchilar</Link>,
            },
          ]
        : []),
    ]
  }, [role])

  const handleMouseEnter = () => {
    if (document.body.classList.contains('mini-sidebar')) {
      document.body.classList.add('expand-menu')
    }
  }

  const handleMouseLeave = () => {
    if (document.body.classList.contains('mini-sidebar')) {
      document.body.classList.remove('expand-menu')
    }
  }

  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu" style={{padding: '10px 0'}}>
              <div className="menu-title" style={{padding: '12px 24px', fontSize: '15px', fontWeight: 500}}>
                Asosiy
              </div>
              <ConfigProvider
                theme={{
                  components: {
                    Menu: {
                      itemBg: '#ffffff',
                      itemColor: 'rgba(51, 53, 72, 0.75)',
                      itemHoverBg: 'rgba(46, 55, 164, 0.05)',
                      itemHoverColor: '#2e37a4',
                      itemSelectedBg: 'rgba(46, 55, 164, 0.05)',
                      itemSelectedColor: '#2e37a4',
                      itemActiveBg: 'rgba(46, 55, 164, 0.05)',
                      itemBorderRadius: 8,
                      itemMarginInline: 12,
                      itemMarginBlock: 8,
                      itemPaddingInline: 16,
                      itemHeight: 50,
                    },
                  },
                }}
              >
                <Menu
                  mode="inline"
                  selectedKeys={[pathname]}
                  items={menuItems}
                  style={{borderRight: 'none', background: 'transparent'}}
                />
              </ConfigProvider>
              <div onClick={onLogout} className="logout-btn" style={{marginTop: '30px'}}>
                <Link>
                  <span className="menu-side">
                    <img src={logout} alt="" />
                  </span>{' '}
                  <span>Chiqish</span>
                </Link>
              </div>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  )
}
